"use strict";
import SocialAppDispatcher from "../dispatcher/SocialAppDispatcher";
import SocialConstants from "../constants/SocialConstants";
import SocialAPIUtils from "../utils/SocialAPIUtils";
import store from "../store";
import Promise from "bluebird";
var ActionTypes = SocialConstants.ActionTypes;
var actions = {
    /**
   *  C O N F I G U R A T I O N
   */ readConfiguration: function() {
        return SocialAPIUtils.readConfiguration();
    },
    /**
   *  D I S C L A I M E R
   */ getDisclaimer: function() {
        SocialAPIUtils.getDisclaimer();
    },
    acceptDisclaimer: function() {
        SocialAPIUtils.acceptDisclaimer();
    },
    /**
   * S P H E R E S
   */ /**
   * @param members {array} of users to add to the sphere
   * @return {Promise} the transaction promise for this create transaction
   *                   The promise will resolve to the "new" sphere.
   */ createSphere: function(sphere) {
        return SocialAPIUtils.createSphere(sphere);
    },
    /**
   * @param sphere {object} describes a sphere (with id, members & name)
   * @return {Promise} the transaction promise for this update transaction
   */ updateSphere: function(sphere) {
        return SocialAPIUtils.updateSphere(sphere);
    },
    /**
   * T O P I C S
   */ /**
   * @param {object} sphere in what communication channel shall it be produced
   * @param {string} topicTitle of the topic
   * @param {object} activity Consists of attrs: body
   * @return {Promise} for this transaction
   */ createTopic: function(sphere, topicTitle, activity) {
        return SocialAPIUtils.createTopic(sphere, topicTitle, activity);
    },
    duplicateTopic: function(sphere, topicTitle, activity, topic) {
        return SocialAPIUtils.duplicateTopic(sphere, topicTitle, activity, topic);
    },
    /**
   * Select a topic
   * @param {number} topicID The ID of the Topic to select
   */ selectTopic: function(topic) {
        SocialAppDispatcher.handleViewAction({
            type: ActionTypes.SELECT_TOPIC,
            rawTopic: topic,
            topicID: topic ? topic.id : null
        });
        if (topic !== null) {
            SocialAPIUtils.getTopic(topic);
        }
    },
    selectSearchedTopic: function(topic, app) {
        SocialAppDispatcher.handleViewAction({
            type: ActionTypes.SELECT_SEARCHED_TOPIC,
            rawTopic: topic,
            topicID: topic ? topic.id : null,
            app: app
        });
        if (topic !== null) {
            if (app === "Note") {
                SocialAPIUtils.getNote(topic);
            } else {
                SocialAPIUtils.getTopic(topic);
            }
        }
    },
    /**
   * Update a topic
   * @param {object} topic
   */ updateTopic: function(topic, activity) {
        return SocialAPIUtils.updateTopic(topic, activity);
    },
    /**
   * Search the topics, based on the given search
   * @param {spheres: [Object], nodes: [Object]} options
   */ getTopics: function(options) {
        SocialAPIUtils.getAllTopics(options);
    },
    /**
   * Search the topics, based on the given search
   * @param {spheres: [Object], nodes: [Object], query: String} options
   */ searchTopics: function searchTopics(options) {
        var searchDispatch = function(topics) {
            SocialAppDispatcher.handleViewAction({
                type: ActionTypes.SEARCH_TOPICS,
                topics: topics,
                notes: options.notes
            });
        };
        SocialAPIUtils.searchTopics(options).then(searchDispatch);
    },
    /**
   * N O T E S
   */ getNotes: function(options) {
        var sphere = store.getState().groups.noteGroup;
        SocialAPIUtils.getNotes(sphere, options);
    },
    selectNote: function(note) {
        SocialAppDispatcher.handleViewAction({
            type: ActionTypes.SELECT_NOTE,
            rawNote: note,
            noteID: note ? note.id : null
        });
        if (note !== null) {
            SocialAPIUtils.getNote(note);
        }
    },
    deleteNote: function(note, nodes) {
        SocialAPIUtils.deleteNote(note, nodes);
    },
    /**
   * A C T I V I T I E S
   */ /**
   * @param activity {object} Consists of attrs: body
   * @param topic {object} Consists of attrs: id
   * @return {Promise} for the async transaction
   */ createActivity: function(activity, topic) {
        return SocialAPIUtils.createActivity(activity, topic);
    },
    /**
   * @param {object} activity Consists of attrs: id, body
   * @param {object} topic in which the activity resides
   * @return {Promise} for the async transaction
   */ updateActivity: function(activity, topic) {
        return SocialAPIUtils.updateActivity(activity, topic);
    },
    /**
   * @param {object} activity Consists of attrs: id, body
   * @param {object} topic in which the activity resides
   * @return {Promise} for the async transaction
   */ deleteActivity: function(activity, topic) {
        return SocialAPIUtils.deleteActivity(activity, topic);
    },
    /**
   * Load all necessary activity data from server
   * @param activity
   * @param topic
   * @returns {Promise} for the async transaction
   */ loadActivity: function(activity, topic) {
        return SocialAPIUtils.getActivity(activity, topic);
    },
    /**
   * Delete a given Asset from the Server
   * @param {object} activity which holds the asset
   * @param {object} asset which should be removed from server
   * @returns {Promise} for the async transaction
   */ deleteAsset: function(activity, id) {
        return SocialAPIUtils.deleteAsset(activity, id);
    },
    getRating: function(target, dimension) {
        SocialAPIUtils.getRating(target, dimension);
    },
    setRating: function(target, dimension, val) {
        SocialAPIUtils.setRating(target, dimension, val);
    },
    /**
   * PLUGINS
   */ saveNodePluginData: function saveNodePluginData(pluginId, nodeId, data) {
        return SocialAPIUtils.savePluginData(pluginId, nodeId, data);
    },
    getCommunityPluginData: function getCommunityPluginData(pluginId, nodeId) {
        return SocialAPIUtils.getCommunityPluginData(pluginId, nodeId);
    },
    getNodePluginData: function getNodePluginData(pluginId, nodeId) {
        return SocialAPIUtils.getPluginData(pluginId, nodeId);
    },
    getCommunityUser: function getCommunityUser() {
        return SocialAPIUtils.getAllUsers();
    },
    getUserProfile: function getUserProfile() {
        return SocialAPIUtils.getUserProfile();
    },
    setUserProfile: function setUserProfile(params) {
        return SocialAPIUtils.setUserProfile(params);
    }
};
export var key = actions.key;
export default actions;
